import { useI18n, type MessageKey } from '@/i18n'
import { Badge } from '@/ui'
import type { PackLot } from '@/offline/sitePack'
import { lotState, type LotState } from '../model/reconcile'

const TONE: Record<LotState, 'info' | 'ok' | 'warn' | 'danger' | 'neutral'> = {
  PACKING: 'info',
  WAITING: 'neutral',
  RELEASED: 'ok',
  HELD: 'warn',
  RECALLED: 'danger',
  WITHDRAWN: 'danger',
}

/** Packing / waiting for release / released / on hold / recalled / withdrawn — hold first. */
export function LotStateBadge({ lot }: { lot: Pick<PackLot, 'status' | 'hold'> }) {
  const { t } = useI18n()
  const s = lotState(lot)
  return <Badge tone={TONE[s]}>{t(`pack.lotState.${s}` as MessageKey)}</Badge>
}
